import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  CreatePersonPhoneCommand,
  PhoneViewModel,
  UpdatePersonPhoneCommand
} from '../models/Entities/Person/Phone/PhoneModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Get all phones of a person
export const GetPhonesByPersonId = async (
  token: string,
  personId: number
): Promise<PhoneViewModel[]> => {
  const requestUrl: string = buildURL(BaseURL, personId, 'phones');
  return apiRequest<PhoneViewModel[]>(requestUrl, token, 'GetPhonesByPersonId');
};

// Get phone by id
export const GetPhoneById = async (
  token: string,
  phoneId: number
): Promise<PhoneViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'phones', phoneId);
  return apiRequest<PhoneViewModel>(requestUrl, token, 'GetPhoneById');
};

// Create phone
export const CreatePhone = async (
  token: string,
  payload: CreatePersonPhoneCommand
): Promise<PhoneViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'phones');
  return apiRequest<PhoneViewModel>(requestUrl, token, 'CreatePhone', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update phone
export const UpdatePhone = async (
  token: string,
  payload: UpdatePersonPhoneCommand
): Promise<PhoneViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'phones');
  return apiRequest<PhoneViewModel>(requestUrl, token, 'UpdatePhone', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete phone
export const DeletePhone = async (
  token: string,
  phoneId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, 'phones', phoneId);
  return apiRequest<number>(requestUrl, token, 'DeletePhone', {
    method: 'DELETE'
  });
};
